import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    adsbygoogle: unknown[];
  }
}

interface AdUnitProps {
  slot: string;
  format?: 'auto' | 'rectangle' | 'horizontal';
  /** Set false for fixed-column sidebar ads — disables full-width-responsive so AdSense serves standard sizes */
  responsive?: boolean;
  className?: string;
}

export function AdUnit({ slot, format = 'auto', responsive = true, className }: AdUnitProps) {
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch {
      // AdSense not loaded yet — ad will remain empty
    }
  }, []);

  const pubId = import.meta.env.VITE_ADSENSE_PUB_ID || 'ca-pub-6974665526310894';

  return (
    <ins
      className={`adsbygoogle ${className ?? ''}`}
      style={{ display: 'block' }}
      data-ad-client={pubId}
      data-ad-slot={slot}
      data-ad-format={format}
      {...(responsive ? { 'data-full-width-responsive': 'true' } : {})}
    />
  );
}
